import type { MouseEventHandler, TouchEventHandler } from "react";
import { useCallback } from "react";

/**
 *
 * @deprecated
 * 削除予定です。onClickを直接利用してください
 */
export const useHandleClickByDevice = () => {
  const handleClickByDevice = useCallback(<T>(fn: MouseEventHandler<T> | TouchEventHandler<T>) => {
    const onClick: MouseEventHandler<T> = (e) => {
      e.preventDefault();
      (fn as MouseEventHandler<T>)(e);
    };
    return {
      onClick,
    };
  }, []);

  return { handleClickByDevice };
};
